export const ACCOUNT_TYPES = {
  PERSONAL: "personal",
  BUSINESS: "business",
};
